
import { FrequencyDocument } from "@/models/base";
import { FrequencyDocumentEditState } from "@/utils/frequency-document-edit-state";
import Vue from "vue";
import { Sale } from "@/models/base";
import { SaleService } from "../../services/sale-service";
import AppDesktopEdit from "./FrequencyDocumentDesktopEdit.vue";
import AppMobileEdit from "./FrequencyDocumentMobileEdit.vue";

export default Vue.extend({
	data() {
		return {
			state: new FrequencyDocumentEditState(this, 1)
		};
	},
	props: {
		value: {
			required: true,
			type: Object as () => FrequencyDocument
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.state.doc = this.value;
				if (!this.state.doc.Sale) {

					this.state.doc.Sale = new Sale();
					this.state.doc.Sale.TypeID = 10;
					SaleService.getType(10).then((t) => {
						this.state.sale.Type = t;
					});
				}
				this.state.setSale(this.state.doc.Sale);
			}
		}
	},
	created() {
		this.state.on("saved", (doc:FrequencyDocument) => this.$emit("input", doc));
	},
	mounted(){
		this.$emit("state", this.state);
	},
	components: {
		AppDesktopEdit,
		AppMobileEdit
	}
});
